import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import router from './router'
import envs from '@/envs'
import _ from 'lodash'
import Cookies from 'js-cookie'
import localStore from '@/utils/localStore'
import Layout from '@/layout/layout.vue'
import svgicon from '@/components/svgicon'

// UI Libraries and plugins
import Fragment from 'vue-fragment'
import VueDaumPostcode from 'vue-daum-postcode'
import { Draggable } from 'draggable-vue-directive'
import vuetify from '@/plugins/vuetify'
import qLoading from './plugins/qLoading'
import qMsgbox from './plugins/qMsgbox.js'
import Toast from "vue-toastification"
import vueMoment from 'vue-moment'

// Global CSS and DevExtreme
import '@/assets/css/win_style.css'
import '@/components/options/dxEnvs.js'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import 'devexpress-diagram/dist/dx-diagram.css'

// ECharts
import '@/assets/theme/echart/index.js'

// i18n
import VueI18n from 'vue-i18n'
import messages from '@/i18n/custom'

Vue.config.productionTip = false

Vue.use(Fragment.Plugin)
Vue.use(VueDaumPostcode, { scriptUrl: "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js" })
Vue.use({
  install(Vue) {
    Vue.directive('draggable', Draggable)
  }
})
Vue.use(vueMoment)
Vue.use(qLoading)
Vue.use(qMsgbox, { aa: Vue })
Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 5,
  newestOnTop: true
})
Vue.use(VueI18n)

Vue.component('svg-icon', svgicon)

// Global properties
Vue.prototype.$envs = envs
Vue.prototype.$Cookies = Cookies
Vue.prototype.$_ = _
Vue.prototype.$localStore = localStore
Vue.prototype.$EventBus = new Vue()
Vue.prototype.$gUtil = require('@/utils/common')

// DevExtreme i18n
import { locale } from 'devextreme/localization'
import {getFnDecrypt } from '@/api/common/login'
import { moceanObj } from './mocean.js'

//import { useRoute } from 'vue-router';


// VueI18n config
const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages
})


const sys_id = '10'
let routeToMocean = false

loadMoceanScript()

//loadMoceanScript()

function initializeCordova() {
  return new Promise((resolve, reject) => {
    window.moceanObj = moceanObj;
    try {
      window.addEventListener('moceanready', async () => {
        try {
          const userId = await window.moceanObj.getUserId();
          window.MOceanID = userId;
          window.__cordova_init = userId !== null;
          routeToMocean = true; 
          resolve(userId);
        } catch (err) {
          window.__cordova_init = false;
          reject(err);
        }
      });

      // fallback nếu sau X giây không có moceanready
      setTimeout(() => {
        reject(new Error("moceanready timeout"));
      }, 2000) ;

    } catch (err) {
      window.__cordova_init = false;
      reject(err);
    }
  });
}

async function loadMoceanScript() {
  try {
    const userId = await initializeCordova();
    setUserDetails(userId);
    router.push({ name: 'moceanLogin', query: { user_id: userId }, meta: { requiresCordova: true }});
  } catch {
    const hash = window.location.hash; // "#/login?user_id=076F4D2A103FD441"
    const queryString = hash.split('?')[1]; // "user_id=076F4D2A103FD441"
    const urlParams = new URLSearchParams(queryString);
    const user_id = urlParams.get("user_id"); 
    let userId = null;
    if (user_id) userId = await getDecryptId(user_id);

    const parentUrl = 'https://smart.hd-hvs.com/#/login'
    //console.log(" userId : " + userId) ;
    //alert("query ID : " + userId)

    if (userId) {
      setUserDetails(userId);
      router.push({ name: 'login', query: { user_id: userId, returnUrl: parentUrl }});
    } else {
      router.push({ name: 'login' }); }
  }

  createVueApp();
}

function setUserDetails(userId) {
  store.commit('system/SET_SYS_CD', sys_id)
  store.commit('system/SET_SYS_ID', sys_id)
  store.commit('user/SET_USER_ID', userId)
  store.commit('user/SET_MOCEAN_ID', userId)
  //localStore.setToken(userId)
  //localStore.setID(userId)
}

function getDecryptId(usrID) {
  return new Promise(async (resolve, reject) => {
    let param = {
      userId : usrID,
    }
    try {
      const res = await getFnDecrypt(param)
        resolve(res.USR_ID);
    }catch(err) {
      reject(err) ;
    }
  })
}


// ─────────────────────────────────────────────────────────────
// 🚀 Vue App Initialization and Delayed Routing
// ─────────────────────────────────────────────────────────────

function createVueApp() {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    methods: {
      async getDynamicRoutes(list) {
        list.forEach(route => {
          if (route.prtId && route.pgmId) this.createAndAppendRoute(route)
        })
        
        const newRoute = {
          path: '/',
          redirect: '/pageNotFound',
          component: Layout,
          children: DynamicRouteInfo
        }
        
        this.$router.addRoutes([newRoute])
      },

      createAndAppendRoute(route) {
        let newRoute = {
          path: `${route.pgmId}`,
          name: `${route.pgmId}`,
          component: () => import(`@/views${route.routerId}.vue`),
          meta: { menu_code: route.pgmId, menu_id: route.pgmId, title: route.ename, affix: false }
        }

        if (route.id === 'cmmcdmng' || route.id === 'mnmng' || route.id === 'mnauthmng') {
          DynamicRouteInfo.push(newRoute)
        } else {
          newRoute.component = () => import(`@/views/mis${route.routerId}.vue`)
          DynamicRouteInfo.push(newRoute)
        }
      }
    },
    render: h => h(App),
    created() {
      locale(this.$i18n.locale)
    }
  }).$mount('#app')
}
